import React from 'react'
import {
    ModalTrigger,
    ModalConfirmTotals,
    ModalAssignNumberOC,
    ModalCancelRequest
} from './Modales.jsx'

export const OptionRequestServices = ({status, dischargeServices, rejectRequest, data, perms}) => {
    return (
        <div>
            <ButtonConfirmTotals
                data={data}
                title={'1.Autorizo solicitud servicios'}
                info={'Para su conocimiento, enviaremos la información de esta confirmación via email a las casillas de correos definidas.'}
                classBtn={status>=2 && status!=5? 'btn-success' : 'btn-info'}
                glyphicon={status>=2 && status!=5? 'glyphicon glyphicon-ok' : 'glyphicon glyphicon-time'}
                action={dischargeServices}
                enabled={status==1 && data.servicesApprove.length > 0 && perms.approveServices}
            />
            <ButtonCancelRequest
                classBtn="btn-warning"
                glyphicon="glyphicon glyphicon-ban-circle"
                action={rejectRequest}
                enabled={status<4 && perms.cancelRequest}
                isServicesApprove={data.servicesApprove.length > 0}
            />
        </div>    
    )
}

export const OptionRequestOC = ({status, dischargeOC, assignOC, data, perms}) => {
    return (
        <div>
            <ButtonConfirmTotals
                data={data}
                title={'2.Autorizo solicitud orden de compra'}
                info={'Para su conocimiento, enviaremos la información de esta autorización via email a las casillas de correos definidas.'}
                classBtn={status>=3 && status!=5? 'btn-success' : 'btn-info'}
                glyphicon={status>=3 && status!=5? 'glyphicon glyphicon-ok' : 'glyphicon glyphicon-time'}
                action={dischargeOC}
                enabled={status==2 && perms.approveOC}
            />
            <ButtonAssignNumberOC
                data={data}
                title={'3.Asignar orden de compra'}
                info={'Atención se enviará información a SEI para generar factura'}
                classBtn={status>=4 && status!=5? 'btn-success' : 'btn-info'}
                glyphicon={status>=4 && status!=5? 'glyphicon glyphicon-ok' : 'glyphicon glyphicon-time'}
                action={assignOC}
                enabled={status==3 && perms.attachOC}
            />
        </div>
    )
}

const ButtonConfirmTotals = ({data, title, info, classBtn, glyphicon, action, enabled}) => {
    return (
        <ModalTrigger>
            {(isVisible, showModal, hideModal) =>
                <button 
                    className={`btn ${classBtn}`}
                    onClick={showModal}
                    disabled={!enabled}
                >
                    {title} <span className={`glyphicon ${glyphicon}`}></span>
                    {isVisible && 
                        <ModalConfirmTotals 
                            data={data}
                            title={title}
                            info={info}
                            hideModal={hideModal}
                            action={action}
                        />
                    }
                </button>
            }
        </ModalTrigger> 
    )
}

const ButtonAssignNumberOC = ({data, title, info, classBtn, glyphicon, action, enabled}) => {
    return (
        <ModalTrigger>
            {(isVisible, showModal, hideModal) =>
                <button
                    className={`btn ${classBtn}`}
                    onClick={showModal}
                    disabled={!enabled}
                >
                    {title} <span className={`glyphicon ${glyphicon}`}></span>
                    {isVisible &&
                    <ModalAssignNumberOC
                        data={data}
                        title={title}
                        info={info}
                        hideModal={hideModal}
                        action={action}
                    />
                    }
                </button>
            }
        </ModalTrigger>
    )
}

const ButtonCancelRequest = ({classBtn, glyphicon, action, enabled, isServicesApprove}) => {
    return (
        <ModalTrigger>
            {(isVisible, showModal, hideModal) =>
                <button
                    className={`btn ${classBtn}`}
                    onClick={showModal}
                    disabled={!enabled}
                >
                    {'Rechazar'} <span className={`glyphicon ${glyphicon}`}></span>
                    {isVisible &&
                    <ModalCancelRequest
                        hideModal={hideModal}
                        action={action}
                        isServicesApprove={isServicesApprove}
                    />
                    }
                </button>
            }
        </ModalTrigger>
    )
}


// WEBPACK FOOTER //
// ./frontEnd/billing/management-oc/OptionRequest.jsx